const SelectQuestsionAction = {
  SET_SELECT_QUESTION: "SET_SELECT_QUESTION",
  UNSET_SELECT_QUESTION: "UNSET_SELECT_QUESTION",
  SET_SELECT_ALL_QUESTION: "SET_SELECT_ALL_QUESTION",
  UNSET_SELECT_ALL_QUESTION: "UNSET_SELECT_ALL_QUESTION",
  RESET_QUESTION: "RESET_QUESTION",
};

export default SelectQuestsionAction;
